<p-dialog
  [visible]="true"
  [modal]="true"
  [closable]="false"
  [showHeader]="true"
  [dismissableMask]="false"
  styleClass="notification-popup"
  [draggable]="false"
>
  <ng-template pTemplate="header" class="p-header">
    <div class="notification-header">Notification</div>
    <i class="pi pi-times close-icon" (click)="closePopup()"></i>
  </ng-template>

  <div class="notification-header-section">
    <div class="unread-label">{{ unreadCount }} Unread notifications</div>
    <div class="mark-read" (click)="markAllRead.emit()" (keydown.enter)="markAllRead.emit()" tabindex="0">Mark all as read</div>
  </div>

  <div class="notification-list">
    <div
      class="notification-item"
      *ngFor="let note of visibleNotifications"
      [ngClass]="{ unread: !note.is_read }"
      (click)="markAsRead(note.id)"
    >
      <div class="info">
        <div class="icon-container"><i class="pi pi-bell"></i></div>
        <div class="text-container">
          <div class="title">{{ note.title }}</div>
          <div class="desc">{{ note.description }}</div>
          <div class="time">{{ note.created_at | date: 'short' }}</div>
        </div>
      </div>

      <!-- <img
        src="assets/icons/top-right.svg"
        alt="icon"
        class="notification-icon"
      /> -->
      <button class="mark_as_read" *ngIf="!note.is_read" (click)="markAsRead(note.id)">mark as read</button>
    </div>
  </div>
</p-dialog>
